import { gql } from "apollo-boost";

// One request for the whole "ความก้าวหน้าการเรียน" page: the student header
// and every subject this term (studx-admin-backend getMyLearnProgress).
export const GET_MY_LEARN_PROGRESS = gql`
  query getMyLearnProgress {
    getStudentByCurrentUser {
      id
      code
      firstNameLocal
      lastNameLocal
      telephone
      prefix { nameLocal }
      faculty { nameLocal }
      curriculum { nameLocal }
    }
    getMyLearnProgress {
      studentEnrollDetailId
      subjectCode
      subjectName
      credit
      learnSpanNo
      sectionNo
      examSpanNo
      totalVdoLength
      totalLearnTime
      totalLearnPercent
      units {
        seq
        totalVdoLength
        totalLearnTime
        learnPercent
        pretestScore
        pretestMaxScore
        posttestScore
        posttestMaxScore
        pretestDone
        posttestDone
      }
    }
  }
`;
